/**
 * All the routes
 */
export const routes = {
	login: "auth/login",
	signup: "auth/signup",
    firebaseLogin: "auth/firebase-login",
	logout: "auth/logout",
	cartItems: "/cart/items",
	cartSync: "/cart/sync",
	products: "/products",
	productImages: (productId) => `/products/${productId}/images`,
	productBasicInfo: (productId) => `/products/${productId}/basic-info`,
	productAttributes: (productId) => `/products/${productId}/attributes`,
	productExtras: (productId) => `/products/${productId}/extras`,
	productAvailability: (productId) => `/products/${productId}/availability`,
	productStock: (productId) => `/products/${productId}/stock`,
	deliveryAddress: "/delivery-addresses",
	orders: "/orders",
	companyOrders: (companyId) => `/companies/${companyId}/orders`,
	businessAnalytics: (companyId) => `/companies/${companyId}/analytics`,
	viewOrder: (companyId, orderId) => `/companies/${companyId}/orders/${orderId}`,
	markOrderAsReady: (companyId, orderId) => `/companies/${companyId}/orders/${orderId}/ready`,
	markOrderAsProcessing: (companyId, orderId) => `/companies/${companyId}/orders/${orderId}/process`,
	payments: "/payments",
	users: "/users",
	userStats: "/users/stats",
	paymentRequests: "/payment-requests",
	reviews: "/reviews",
	capaPurchases: "/capa-purchases",
	aiCreditPurchases: "/ai-credit-purchases",
	orderPaymentSurpluses: "/order-payment-surpluses",
	settings: "/user-settings",
	awards: "/awards",
	transfers: "/transfers",
	follows: "/follows",
	businesses: "/businesses",
	comments: "/comments",
	mentions: "/mentions",
	deliverers: "/deliverers",
	errands: "/errands",
};